import React from 'react';
import { Box, Grid, Skeleton, Paper } from '@mui/material';

function PowerCostLoadingSkeleton() {
    return (
        <Box sx={{ width: '100%' }}>
            {/* KPI Cards Skeletons */}
            <Grid container spacing={2.5} sx={{ mb: 3 }}>
                {[1, 2, 3, 4].map((item) => (
                    <Grid size={{ xs: 12, sm: 6, md: 3 }} key={item}>
                        <Paper sx={{ p: 2.5, borderRadius: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                <Skeleton variant="text" width="40%" height={20} />
                                <Skeleton variant="circular" width={34} height={34} />
                            </Box>
                            <Skeleton variant="text" width="65%" height={48} />
                            <Skeleton variant="text" width="80%" height={20} sx={{ mt: 1 }} />
                        </Paper>
                    </Grid>
                ))}
            </Grid>

            {/* Charts Skeleton */}
            <Grid container spacing={3} sx={{ mb: 3 }}>
                <Grid size={{ xs: 12, lg: 8 }}>
                    <Paper sx={{ p: 3, borderRadius: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                            <Skeleton variant="text" width="35%" height={32} />
                            <Skeleton variant="rectangular" width={180} height={32} sx={{ borderRadius: 1 }} />
                        </Box>
                        <Skeleton variant="rectangular" width="100%" height={320} sx={{ borderRadius: 1 }} />
                    </Paper>
                </Grid>
                <Grid size={{ xs: 12, lg: 4 }}>
                    <Paper sx={{ p: 3, borderRadius: 2 }}>
                        <Skeleton variant="text" width="50%" height={32} sx={{ mb: 2 }} />
                        <Skeleton variant="circular" width={180} height={180} sx={{ mx: 'auto', mb: 2 }} />
                        <Skeleton variant="rectangular" width="100%" height={80} sx={{ borderRadius: 1 }} />
                    </Paper>
                </Grid>
            </Grid>

            {/* Table Skeleton */}
            <Paper sx={{ p: 3, borderRadius: 2 }}>
                <Skeleton variant="text" width="30%" height={32} sx={{ mb: 2 }} />
                {[1, 2, 3, 4, 5].map((item) => (
                    <Skeleton key={item} variant="rectangular" width="100%" height={40} sx={{ mb: 1, borderRadius: 1 }} />
                ))}
            </Paper>
        </Box>
    );
}

export default PowerCostLoadingSkeleton;
